export default __webpack_public_path__ + "static/media/ic-ectangle.c05cdb87.svg";